module.exports = __webpack_public_path__ + "static/img/lz4.90da040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lz4.png
// module id = 4GkL
// module chunks = 130